module.exports = __webpack_public_path__ + "img/result-bg-top.064b8933.png";